var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#3B3936"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 42C53.6424 42 54.9777 42.5531 55.9623 43.5377C56.9469 44.5223 57.5 45.8576 57.5 47.25V49C57.5 55.8985 50.99 63 40 63C29.01 63 22.5 55.8985 22.5 49V47.25C22.5 45.8576 23.0531 44.5223 24.0377 43.5377C25.0223 42.5531 26.3576 42 27.75 42H52.25ZM40 19.25C42.5527 19.25 45.0009 20.2641 46.8059 22.0691C48.6109 23.8741 49.625 26.3223 49.625 28.875C49.625 31.4277 48.6109 33.8759 46.8059 35.6809C45.0009 37.4859 42.5527 38.5 40 38.5C37.4473 38.5 34.9991 37.4859 33.1941 35.6809C31.3891 33.8759 30.375 31.4277 30.375 28.875C30.375 26.3223 31.3891 23.8741 33.1941 22.0691C34.9991 20.2641 37.4473 19.25 40 19.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.0757530c7b0512e004858b311ffe54eb.svg";
export { ForwardRef as ReactComponent };